import React, { useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, FormHelperText,
    useMediaQuery, Button
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { MaterialMaster } from '../TitleList';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { createMaterialEntry } from '../../Store/PHPSlice/Material';
import { useDispatch } from 'react-redux';
import MaterialTable from '../MasterTables/MaterialTbl/MaterialTable';
import { errorStyles } from '../../Utils/table';


const MaterialEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        materialNm: '',
        desp: '',
        size: '',
        pkts: '',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.materialNm) newErrors.materialNm = 'Material Name is required';
        if (!formData.desp) newErrors.desp = 'Description is required';
        if (!formData.size) newErrors.size = 'Size is required';
        if (!formData.pkts) newErrors.pkts = 'Packets is required';
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        dispatch(createMaterialEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Material Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>
            <Titlebar data={MaterialMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Material Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                {[
                                    { label: 'Material Name', name: 'materialNm' },
                                    { label: 'Description', name: 'desp' },
                                    { label: 'Size', name: 'size' },
                                    { label: 'Packets', name: 'pkts' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>

                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

                <MaterialTable />
            </div>
        </>
    );
}

export default MaterialEntry;
